<div class="container">
    <div class="card">
      <h4 class="card-header"> Add User</h4>
      <div class="card-body">
        <form action="" #ref =ngForm>
            
          <div class="row">
            <div class="col-6">
              <label for="firstName" class="form-label">First Name</label>
              <input type="text" name="firstName" [(ngModel)]="addUserObj.firstName" class="form-control" id="firstName" placeholder="Ex.Jyothi babu">
            </div>
            <div class="col-6" >
              <label for="lastName" class="form-label">Last Name</label>
              <input type="text" name="lastName" [(ngModel)]="addUserObj.lastName" class="form-control" id="lastName" placeholder="Ex. Valagala">
            </div>
          </div>
        
          <div class="row">
            <div class="col-6">
              <label for="mobileNumber" class="form-label">Mobile Number</label>
              <input type="text" name="mobileNumber" [(ngModel)]="addUserObj.mobileNumber" class="form-control" id="mobileNumber" placeholder="Enter 10 digits number">
            </div>
            <div class="col-6" >
              <label for="emailAddrs" class="form-label">Email Address</label>
              <input type="email" name="emailAddrs" [(ngModel)]="addUserObj.emailAddrs" class="form-control" id="emailAddrs" placeholder="Ex.abc@gmail.com">
            </div>
          </div>
        
          <div class="row">
            <div class="col-6 field">
              <label for="password" class="form-label">Password</label>
              <input [type]="showPassword? 'text':'password'" name="password" [(ngModel)]="addUserObj.password" class="form-control" id="password" placeholder="Enter Password">
              <i class="fa-solid fa-eye" *ngIf="!showPassword"></i>
              <i class="fa-solid fa-eye-slash" *ngIf="showPassword"></i>
            </div>
            <div class="col-6" >
              <label for="cPassword" class="form-label">Confirm Password</label>
              <input type="password" name="confirmPassword" [(ngModel)]="addUserObj.confirmPassword" class="form-control" id="cPassword" placeholder="Confirm Password">
            </div>
          </div>
        
          <div class="row">
            <div class="col-6">
              <label for="designation" class="form-label">Designation</label>
              <select class="form-select" name="designation" [(ngModel)]="addUserObj.designation" aria-label="Default select example" id="designation">
                <option selected selected disabled value="">Select Designation</option>
                <option value="1">Intern</option>
                <option value="2">SDE1</option>
                <option value="3">SDE2</option>
            </select>
            </div>
            <div class="col-6">
              <label for="siteLocation" class="form-label">Site Location</label>
              <select class="form-select" name="siteLocation" [(ngModel)]="addUserObj.siteLocation" id="siteLocation">
                <option selected disabled value="">Select Site</option>
                <option value="1">Visakhapatnam</option>
                <option value="2">Hyderabad</option>
                <option value="3">Mumbai</option>
            </select>
            </div>
          </div>
        
          <div class="row">
            <div class="col-6">
              <label for="city" class="form-label">City</label>
              <select class="form-select" name="city" [(ngModel)]="addUserObj.city" aria-label="Default select example" id="city">
                <option selected selected disabled value="">Select City</option>
                <option value="1">Bangalore</option>
                <option value="2">Hyderabad</option>
                <option value="3">Delhi</option>
            </select>
            </div>
            <div class="col-6">
              <label for="state" class="form-label">State</label>
              <select class="form-select" name="state" [(ngModel)]="addUserObj.state" aria-label="Default select example" id="state">
                <option selected selected disabled value="">Select State</option>
                <option value="1">Andhra Pradesh</option>
                <option value="2">Telangana</option>
                <option value="3">Karnataka</option>
            </select>
            </div>
          </div>
        
          <div class="row">
            <div class="col-6">
              <label for="role" class="form-label">Role</label>
              <select class="form-select" name="role" [(ngModel)]="addUserObj.role" aria-label="Default select example" id="role">
                <option selected selected disabled value="">Select Role</option>
                <option value="1">Developer</option>
                <option value="2">Tester</option>
                <option value="3">Team Lead</option>
            </select>
            </div>
          </div>
        </form>
      </div>

      <div class="cancelAndFooter">
        <button class="btn m-2"> cancel </button>
        <button class="btn btn-primary m-2" (click)="onSubmit()">save</button>
      </div>
   
    </div>
  </div>
